import { apiRequest } from '@/shared/api';

import type {
  FuncoinBalance,
  CreatePredictionPayload,
  CreatePredictionResult,
  Prediction,
  PredictionPopup,
} from '../model/types';

export function createPrediction(
  payload: CreatePredictionPayload,
): Promise<CreatePredictionResult> {
  return apiRequest<CreatePredictionResult>('/predictions', {
    method: 'POST',
    body: payload,
  });
}

export function fetchMyPredictions(): Promise<Prediction[]> {
  return apiRequest<Prediction[]>('/predictions/mine');
}

export function fetchFuncoins(): Promise<FuncoinBalance> {
  return apiRequest<FuncoinBalance>('/predictions/funcoins');
}

export function fetchPopup(): Promise<PredictionPopup> {
  return apiRequest<PredictionPopup>('/predictions/popup');
}

export function markPopupSeen(): Promise<{ marked: number }> {
  return apiRequest<{ marked: number }>('/predictions/popup/seen', {
    method: 'POST',
  });
}
